import { useState } from 'react';
import { Globals } from 'utils';

type FallbackImageProps = {
  src: string
  placeholder: string
  className: string
  placeholderClassName: string
  isExternal?: boolean
}

const FallbackImage = ({ src, placeholder, className, placeholderClassName, isExternal = false }: FallbackImageProps) => {
  const uri = isExternal ? src : Globals.fromPhotos(src);
  const [isBroken, setIsBroken] = useState(false);

  if (!src || isBroken) return (
    <img src={placeholder} className={placeholderClassName} alt="Foto de usuario" />
  );

  return (
    <img src={uri} className={className} onError={() => setIsBroken(true)} alt="Foto de usuario" />
  );
};

export default FallbackImage;
